import api from "./../api";
import UtilsUrl from "../../utils/UtilsUrl";
export function getWorkOrderById({ queryKey }) {
  const [_, id] = queryKey;

  return api
    .get(UtilsUrl.productionURL() + `/work-orders/${id}`)
    .then((res) => res.data);
}

export function patchWorkOrder({ data, workOrderId }) {
  return api
    .patch(UtilsUrl.productionURL() + `/work-orders/${workOrderId}`, data, {
      headers: { "Content-Type": "application/json-patch+json" },
    })
    .then((res) => res.data);
}

export function createTimeLog({ workOrderId, timeLog }) {
  return api
    .post(
      UtilsUrl.productionURL() + `/time-logs?workOrderId=${workOrderId}`,
      timeLog
    )
    .then((res) => res.data);
}

export function getTimeLogsForWorkOrder({ queryKey }) {
  const [_, workOrderId] = queryKey;
  return api
    .get(UtilsUrl.productionURL() + `/time-logs?workOrderId=${workOrderId}`)
    .then((res) => res.data);
}
